import "./utils-b089Z84x.js";
import { defineAsyncComponent as e } from "vue";
import { getI18n as t } from "@editor/ui-utils";
//#endregion
//#region src/lang/index.ts
var n = {
	en: {
		articlePushApi: {
			createAlreadyExists: "The article push cannot be created because another article push with this title already exists.",
			updateAlreadyExists: "The article push cannot be updated because another article push with this title already exists.",
			created: "Article push created",
			updated: "Article push updated",
			notFound: "Article push not found",
			requiredFields: "The article push cannot be saved because mandatory information is missing."
		},
		articlePushList: {
			newButton: "New article push",
			name: "Search for push headline or channel",
			deleteArticlePush: "Delete",
			dpAny: "All",
			brand: "Brand",
			loading: "Loading article push",
			headerLabel: "Label",
			headerCreatedAt: "Creation date",
			headerChangedAt: "Last modified date",
			counter: "Counter",
			dpEdit: "Edit",
			dpView: "View",
			messageDeleted: "Message deleted",
			errorOnDeleting: "Error deleting",
			createArticlePush: "Create article push",
			goToArticle: "Go to article",
			editArticle: "Edit article",
			title: "Push main title",
			status: "Status",
			pending: "Pending",
			failure: "Failure",
			partialSuccess: "Partial success",
			success: "Success",
			kickerTitle: "Kicker, main title",
			channel: "Channel",
			headerPublished: "Publish date",
			pushed: "Push date",
			pushedBy: "Pushed by",
			showStatusDetail: "Show Cleverpush status detail",
			statusDetailDisclaimer: "Use Cleverpush UI to validate push notification send status.",
			statusDetailPendingDisclaimer: "Waiting for response from Cleverpush"
		},
		articlePush: {
			articlePushLabel: "ArticlePush",
			newArticlePush: "New article push",
			messageDeleteArticlePush: "Delete article push",
			messageDeleteArticlePushTitle: "Are you sure you want to delete this article push?",
			deleteArticlePush: "Delete",
			messageDeleted: "Article push deleted",
			errorOnDeleting: "Error deleting the article push",
			errorFailedLoadedArticlePushWithId: "Error getting the article push",
			messageSaved: "Article pushed",
			pushKicker: "Push kicker",
			pushHeadline: "Push headline",
			channel: "Channel",
			pushNotification: "Push",
			savePush: "Save & push",
			publishPush: "Publish & push",
			push: "Push",
			pushAndBanner: "Push & banner",
			articlePushAlreadySent: "A push notification for this article was already sent on {date}.",
			breakingNewsCheckbox: "Breaking news"
		},
		banner: {
			tabLabel: "Banner",
			requiredFields: "Banner with invalid data cannot be saved",
			expiresAtMessage: "The banner will be deactivated at {time} (in {inMinutes} minutes) on {date}.",
			expiredMessage: "The banner was deactivated at {time} on {date}.",
			expireInputLabel: "Duration from saving (in minutes)",
			headlineInputLabel: "Banner headline",
			stopBannerButton: "STOP BANNER",
			states: {
				active: "Active",
				notVisible: "Not visible",
				expired: "Unpublished"
			}
		},
		articlePushEdit: {
			label: "Label",
			counter: "Counter",
			goToPage: "To page",
			editArticlePush: "Edit article push",
			pushNotification: "Push notification",
			messageSaved: "Article pushed"
		}
	},
	de: {
		articlePushApi: {
			createAlreadyExists: "Der Artikel-Push kann nicht erstellt werden, weil bereits ein Artikel-Push mit diesem Titel existiert.",
			updateAlreadyExists: "Der Artikel-Push kann nicht aktualisiert werden, weil schon ein Artikel-Push mit diesem Titel existiert.",
			created: "Artikel-Push erstellt",
			updated: "Artikel-Push aktualisiert",
			notFound: "Artikel-Push nicht gefunden",
			requiredFields: "Der Artikel-Push kann nicht gespeichert werden, weil Pflichtinformationen fehlen."
		},
		articlePushList: {
			newButton: "Neuer Artikel-Push",
			name: "Suchen nach Push-Überschrift oder Channel",
			deleteArticlePush: "Löschen",
			dpAny: "Alle",
			brand: "Marke",
			loading: "Artikel-Push wird geladen",
			headerLabel: "Bezeichnung",
			headerCreatedAt: "Erstellungdatum",
			headerChangedAt: "Änderungsdatum (last modified)",
			counter: "Zähler",
			dpEdit: "Bearbeiten",
			dpView: "Anzeigen",
			messageDeleted: "Nachricht gelöscht",
			errorOnDeleting: "Fehler beim Löschen",
			createArticlePush: "Artikel-Push erstellen",
			goToArticle: "Zum Artikel",
			editArticle: "Artikel bearbeiten",
			title: "Push-Hauptzeile",
			status: "Status",
			pending: "Ausstehend",
			failure: "Fehler",
			partialSuccess: "Teilerfolg",
			success: "Erfolg",
			kickerTitle: "Vorzeile, Hauptzeile",
			channel: "Channel",
			headerPublished: "Veröffentlichungsdatum (publish date)",
			pushed: "Push-Datum",
			pushedBy: "Gepusht von",
			showStatusDetail: "Details zum Cleverpush-Status anzeigen",
			statusDetailDisclaimer: "Die Cleverpush-Benutzeroberfläche verwenden, um den Sendestatus von Push-Benachrichtigungen zu prüfen.",
			statusDetailPendingDisclaimer: "Warten auf Antwort von Cleverpush"
		},
		articlePush: {
			articlePushLabel: "ArticlePush",
			newArticlePush: "Neuer Artikel-Push",
			messageDeleteArticlePush: "Artikel-Push löschen",
			messageDeleteArticlePushTitle: "Willst du diesen Artikel-Push wirklich löschen?",
			deleteArticlePush: "Löschen",
			messageDeleted: "Artikel-Push gelöscht",
			errorOnDeleting: "Fehler beim Löschen des Artikel-Pushs",
			errorFailedLoadedArticlePushWithId: "Fehler beim Abrufen des Artikel-Pushs",
			messageSaved: "Artikel gepusht",
			pushKicker: "Push-Vorzeile",
			pushHeadline: "Push-Hauptzeile",
			channel: "Channel",
			pushNotification: "Pushen",
			savePush: "Speichern & pushen",
			publishPush: "Veröffentlichen & Pushen",
			push: "Pushen",
			pushAndBanner: "Pushen & Banner",
			articlePushAlreadySent: "Dieser Artikel wurde bereits am {date} gepusht.",
			breakingNewsCheckbox: "Eilmeldung"
		},
		banner: {
			tabLabel: "Banner",
			requiredFields: "Banner kann mit ungültigen Daten nicht gespeichert werden",
			expiresAtMessage: "Das Banner wird um {time} (in {inMinutes} Minuten) am {date} deaktiviert.",
			expiredMessage: "Das Banner wurde um {time} am {date} deaktiviert.",
			expireInputLabel: "Anzeigedauer ab Speicherzeitpunkt (in min)",
			headlineInputLabel: "Banner-Überschrift",
			stopBannerButton: "Banner beenden",
			states: {
				active: "Aktiv",
				notVisible: "Nicht sichtbar",
				expired: "Depubliziert"
			}
		},
		articlePushEdit: {
			label: "Bezeichnung",
			counter: "Zähler",
			goToPage: "Zur Seite",
			editArticlePush: "Artikel-Push bearbeiten",
			pushNotification: "Push",
			messageSaved: "Artikel gepusht"
		}
	}
}, r = "/article-push", i = [{
	path: r,
	meta: { i18RouteTitleKey: "article-push" },
	children: [
		{
			path: "",
			name: "article_push_list",
			component: () => import("./article-push-list.view-FqZJk9GX.js"),
			meta: { requiredRight: "article-pushes:navigate" }
		},
		{
			path: "new",
			name: "article_push_new",
			component: () => import("./article-push-edit.view-BB4t_t0I.js"),
			props: () => ({
				title: t().t("articlePush.newArticlePush"),
				backRoute: "/article-push"
			}),
			meta: { requiredRight: ["article-pushes:navigate"] }
		},
		{
			path: ":id",
			name: "article_push_detail",
			component: () => import("./article-push-edit.view-BB4t_t0I.js"),
			props: (e) => ({
				title: t().t("articlePushEdit.editArticlePush"),
				id: e.params.id,
				backRoute: "/article-push"
			}),
			meta: { requiredRight: ["article-pushes:navigate"] }
		}
	]
}], a = e(() => import("./article-push-modal-D6PceG-w.js")), o = e(() => import("./article-push-action-button-B7f1DH6g.js")), s = {
	messages: n,
	routes: i,
	contentBlocks: []
};
//#endregion
export { r as i, a as n, s as r, o as t };

//# sourceMappingURL=src-Bh9AbVSC.js.map